import {
  DEV_DOMAIN,
  DEV_ENVIRONMENT,
  DEV_FRONTEND_PORT,
  LOOPBACK_IP,
  STAGING_DOMAIN,
  STAGING_ENVIRONMENT,
  PRODUCTION_DOMAIN,
  PRODUCTION_ENVIRONMENT
} from "../constants/general";
import {
  BLIND_SHIPPING,
  BORDER_TYPE,
  CANVAS_DEPTH,
  DIGITAL_PROOF,
  HANGING_KIT,
  FLOATER_FRAME,
  IMAGE_BORDER_TYPE,
  METAL_EASEL,
  MOUNTING_STUDS,
  NEXT_DAY_SHIPPING,
  NEXT_DAY_SHIPPING_PROMO,
  PAPER_TYPE,
  PRIORITY_HANDLING,
  PRIORITY_SHIPPING
} from "../constants/productOptions";

export default class FeatureSwitches {
  constructor() {}

  // TODO: Replace this logic with node's process.env variables.
  currentEnv() {
    let env = DEV_ENVIRONMENT;

    switch (location.host) {
      case `${DEV_DOMAIN}:${DEV_FRONTEND_PORT}`:
      case `${LOOPBACK_IP}:${DEV_FRONTEND_PORT}`:
        env = DEV_ENVIRONMENT;
      case STAGING_DOMAIN:
        env = STAGING_ENVIRONMENT;
      case PRODUCTION_DOMAIN:
        env = PRODUCTION_ENVIRONMENT;
    }

    return env;
  }

  setFeatures() {
    const url = location.host;
    const features = {};
    switch (url) {
      case `${DEV_DOMAIN}:${DEV_FRONTEND_PORT}`:
      case `${LOOPBACK_IP}:${DEV_FRONTEND_PORT}`:
        features.location = url;
        features.customSize60 = false;
        features.maxSingleCanvasWidth = 61;
        features.maxSingleCanvasHeight = 61;
        features.minSingleCanvasSize = 8;
        features.proxyAllUploads = true;
        features.customizeImage = true;
        break;
      case STAGING_DOMAIN:
        features.location = url;
        features.customSize60 = false;
        features.maxSingleCanvasWidth = 61;
        features.maxSingleCanvasHeight = 61;
        features.minSingleCanvasSize = 8;
        features.proxyAllUploads = true;
        features.customizeImage = true;
        break;
      case PRODUCTION_DOMAIN:
        features.location = url;
        features.customSize60 = false;
        features.maxSingleCanvasWidth = 61;
        features.maxSingleCanvasHeight = 61;
        features.minSingleCanvasSize = 8;
        features.proxyAllUploads = true;
        features.customizeImage = true;
        break;
      default:
        features.location = url;
        features.customSize60 = false;
        features.maxSingleCanvasWidth = 61;
        features.maxSingleCanvasHeight = 61;
        features.minSingleCanvasSize = 8;
        features.proxyAllUploads = true;
        features.customizeImage = false;
        break;
    }
    return features;
  }

  setOptions(optionOrder = []) {
    const url = location.host;
    const features = {};

    features.location = url;

    features.options = [
      {
        label: "blind_shipping",
        name: "BLIND SHIPPING",
        handle: BLIND_SHIPPING,
        title: "Blind Shipping",
        cod_tooltip_inner:
          "Removes any branding & logos from the finished canvas & its packaging. Select this option if you’re creating a print for a client or customer.",
        type: "checkbox",
        index: 11,
        values: [
          {
            label: "Yes (+$29.99)",
            value: "Yes (+$29.99)",
            price: 29.99,
            selected: false,
            sku: "CP-OPT-BLND_YES-0000-001",
          },
          {
            label: "Yes (+$0.00)",
            value: "Yes (+$0.00)",
            price: 0,
            selected: false,
            sku: "CP-OPT-B2B_BLND_YES-0000-001",
          },
          {
            label: "No",
            value: "No",
            price: 0,
            selected: true,
            sku: "CP-OPT-BLND_NO-0000-001",
          },
        ],
        enabledIn: [
          DEV_ENVIRONMENT,
          STAGING_ENVIRONMENT,
          PRODUCTION_ENVIRONMENT,
        ],
      },
      {
        label: "next_day_shipping",
        name: "PRIORITY PRODUCTION",
        handle: NEXT_DAY_SHIPPING,
        title: "Priority Production",
        cod_tooltip_inner:
          "Selecting this option will expedite your order through production so it ships the next business day after it is received, instead of our standard 3-day production period. Orders placed after 3 pm EST will not be received until the next business day. Priority Production does not reflect the ground transport travel time.",
        type: "checkbox",
        index: 10,
        values: [
          {
            label: "Yes (+$29.99)",
            value: "Yes (+$29.99)",
            price: 29.99,
            selected: false,
            sku: "CP-OPT-NDS_YES-0000-001",
          },
          {
            label: "No",
            value: "No",
            price: 0,
            selected: true,
            sku: "CP-OPT-NDS_NO-0000-001",
          },
        ],
        enabledIn: [
           DEV_ENVIRONMENT,
           STAGING_ENVIRONMENT,
           PRODUCTION_ENVIRONMENT,
        ],
      },
      // {
      //   label: "digital_proof",
      //   name: "DIGITAL PROOF",
      //   handle: DIGITAL_PROOF,
      //   title: "Digital Proof",
      //   cod_tooltip_inner:
      //     "Receive a digital mock-up of exactly what your finished canvas print will look like with the border attached. Priority Production is not available with this option.",
      //   type: "checkbox",
      //   index: 9,
      //   values: [
      //     {
      //       label: "Yes (+$6.99)",
      //       value: "Yes (+$6.99)",
      //       price: 6.99,
      //       selected: false,
      //       sku: "CP-OPT-DGTL_PROOF-0000-001",
      //     },
      //     {
      //       label: "No",
      //       value: "No",
      //       price: 0,
      //       selected: true,
      //       sku: "CP-OPT-DGTL_PROOF-0000-002",
      //     },
      //     {
      //       label: "Yes (+$20.97)",
      //       value: "Yes (+$20.97)",
      //       price: 20.97,
      //       selected: false,
      //       sku: "CP-OPT-DGTL_PROOF-0000-003",
      //     },
      //   ],
      //   enabledIn: [
      //     DEV_ENVIRONMENT,
      //     STAGING_ENVIRONMENT,
      //     PRODUCTION_ENVIRONMENT,
      //   ],
      // },
      // {
      //   label: "hanging_kit",
      //   name: "HANGING KIT",
      //   handle: HANGING_KIT,
      //   title: "Hanging Kit",
      //   cod_tooltip_inner:
      //     "This is an additional option where a wire is attached to the wood frame the canvas is stretched over that allows you to easily hang your canvas print. Otherwise, the canvas comes with a sawtooth hanger.",
      //   hanging: true,
      //   type: "select",
      //   index: 4,
      //   values: [
      //     {
      //       label: "Yes (+$7.99)",
      //       value: "Yes (+$7.99)",
      //       price: 7.99,
      //       selected: true,
      //       sku: "CP-OPT-HANGING_KIT_YES-0000-001",
      //     },
      //     {
      //       label: "No",
      //       value: "No",
      //       price: 0,
      //       selected: false,
      //       sku: "CP-OPT-HANGING_KIT_NO-0000-001",
      //     },
      //   ],
      //   enabledIn: [
      //     DEV_ENVIRONMENT,
      //     STAGING_ENVIRONMENT,
      //     PRODUCTION_ENVIRONMENT,
      //   ],
      // },
      {
        label: "image_border_type",
        name: "IMAGE BORDER TYPE",
        handle: IMAGE_BORDER_TYPE,
        title: "Image Border Type",
        cod_tooltip_inner:
          "We offer three different types of border types; blur, mirrored, and colored (Black, White, and Gray). These are additional customization options that add a specific type of border edge to your prints.",
        type: "select",
        index: 2,
        values: [
          {
            label: "Blur",
            value: "Blur",
            price: 0,
            selected: true,
            image:
              "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/border_blur.png",
            sku: "CP-OPT-BRDER_BLUR-0000-001",
          },
          {
            label: "Black (+$6.00)",
            value: "Black (+$6.00)",
            price: 6,
            selected: false,
            image:
              "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/border_black.png",
            sku: "CP-OPT-BRDER_BLACK-0000-001",
          },
          {
            label: "Grey (+$6.00)",
            value: "Grey (+$6.00)",
            price: 6,
            selected: false,
            image:
              "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/border_gray.png",
            sku: "CP-OPT-BRDER_GREY-0000-001",
          },
          {
            label: "Mirror (+$6.00)",
            value: "Mirror (+$6.00)",
            price: 6,
            selected: false,
            image:
              "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/border_mirror.png",
            sku: "CP-OPT-BRDER_MIRROR-0000-001",
          },
          {
            label: "White (+$6.00)",
            value: "White (+$6.00)",
            price: 6,
            selected: false,
            image:
              "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/border_white.png",
            sku: "CP-OPT-BRDER_WHITE-0000-001",
          },
        ],
        enabledIn: [
          DEV_ENVIRONMENT,
          STAGING_ENVIRONMENT,
          PRODUCTION_ENVIRONMENT,
        ],
      },
      {
        label: "canvas_depth",
        name: "CANVAS DEPTH",
        handle: CANVAS_DEPTH,
        title: "Canvas Depth",
        cod_tooltip_inner:
          "Canvas depth refers to the thickness of the canvas.. We offer our canvas depth in two options, 0.75” or 1.5”. Canvases over the size of 18”x24” are automatically constructed on the 1.5” depth for maximum stability and cannot be changed.",
        type: "select",
        selected: true,
        index: 3,
        values: [
          {
            value: "0.75",
            price: 0,
            selected: true,
            label: "0.75",
            sku: "CP-OPT-DEPTH_0.75-0000-001",
          },
          {
            value: "1.5 (+$6.00)",
            price: 6,
            label: "1.25 (+$6.00)",
            selected: false,
            sku: "CP-OPT-DEPTH_1.5-0000-001",
          },
        ],
        enabledIn: [
          DEV_ENVIRONMENT,
          STAGING_ENVIRONMENT,
          PRODUCTION_ENVIRONMENT,
        ],
      },
      {
        label: "border",
        name: "BORDER",
        handle: BORDER_TYPE,
        title: "Border Type",
        cod_tooltip_inner: "Border",
        type: "select",
        selected: true,
        index: 5,
        values: [
          {
            value: "Full bleed",
            price: 0,
            selected: true,
            label: "Full bleed",
            sku: "CP-OPT-BLEED_FULL-0000-001",
          },
          {
            value: '1"',
            price: 0,
            label: '1"',
            selected: false,
            sku: "CP-OPT-BLEED_1-0000-001",
          },
          {
            value: '0.5"',
            price: 0,
            label: '0.5"',
            selected: false,
            sku: "CP-OPT-BLEED_0.5-0000-001",
          },
        ],
        enabledIn: [
          DEV_ENVIRONMENT,
          STAGING_ENVIRONMENT,
          PRODUCTION_ENVIRONMENT,
        ],
      },
      {
        label: "paper_type",
        name: "PAPER TYPE",
        handle: PAPER_TYPE,
        title: "Paper Type",
        cod_tooltip_inner:
          "We offer Matte, Semi-Gloss, and Glossy paper types for poster prints.",
        type: "select",
        selected: true,
        index: 6,
        values: [
          // {
          //   value: "Glossy",
          //   price: 0,
          //   selected: true,
          //   label: "Glossy",
          //   sku: "CP-OPT-PAPER_GLOSS-0000-001",
          // },
          {
            value: "Semi-gloss",
            price: 0,
            label: "Semi-gloss",
            selected: true,
            sku: "CP-OPT-PAPER_SEMIGLOSS-0000-001",
          },
          {
            value: "Matte",
            price: 0,
            label: "Matte",
            selected: false,
            sku: "CP-OPT-PAPER_MATTE-0000-001",
          }
        ],
        enabledIn: [
          DEV_ENVIRONMENT,
          STAGING_ENVIRONMENT,
          PRODUCTION_ENVIRONMENT,
        ],
      },
      {
        label: "floater_frame",
        name: "FLOATER FRAME",
        handle: FLOATER_FRAME,
        title: "Floater Frame",
        cod_tooltip_inner:
          "Our 100% USA-grown popular wood floating frames enhance and finish the look of your canvas print by giving it a floating appearance on your wall. The art will appear suspended within the frame rather than extending towards the edge of the frame itself. Choose the frame finish that best compliments the color palette of your artwork and living space to create a one-of-a-kind piece of art. Finish options are Black, White, Gold, Natural, Espresso, and Barnwood Gray.",
        type: "image",
        selected: true,
        index: 1,
        values: [
          {
            value: "None",
            price: 0,
            selected: true,
            label: "None",
            sku: "CP-OPT-FRAME_NONE-0000-001",
          },
          // {
          //   value: '1.25" White',
          //   price: 0,
          //   label: '.75" White',
          //   color: "white",
          //   depth: "1-25",
          //   selected: false,
          //   image:
          //     "https://canvas-prints-public.s3.amazonaws.com/CAF_6899+thumb.png",
          //   sku: "CP-OPT-FLOATER_FRAME_WHITE_1.25-0000-001",
          // },
          {
            value: '2" White',
            price: 0,
            label: '1.25" White',
            color: "white",
            depth: "2",
            selected: false,
            image:
              "https://canvas-prints-public.s3.amazonaws.com/CAF_6899+thumb.png",
            sku: "CP-OPT-FLOATER_FRAME_WHITE_2-0000-001",
          },
          // {
          //   value: '1.25" Black',
          //   price: 0,
          //   label: '.75" Black',
          //   color: "black",
          //   depth: "1-25",
          //   selected: false,
          //   image:
          //     "https://canvas-prints-public.s3.amazonaws.com/CAF_6906+thumb.png",
          //   sku: "CP-OPT-FLOATER_FRAME_BLACK_1.25-0000-001",
          // },
          {
            value: '2" Black',
            price: 0,
            label: '1.25" Black',
            color: "black",
            depth: "2",
            selected: false,
            image:
              "https://canvas-prints-public.s3.amazonaws.com/CAF_6906+thumb.png",
            sku: "CP-OPT-FLOATER_FRAME_BLACK_2-0000-001",
          },
          // {
          //   value: '1.25" Gold',
          //   price: 0,
          //   label: '1.25" Gold',
          //   color: "gold",
          //   depth: "1-25",
          //   selected: false,
          //   image:
          //     "https://canvas-prints-public.s3.amazonaws.com/CAF_6893+thumb.png",
          //   sku: "CP-OPT-FLOATER_FRAME_GOLD_1.25-0000-001",
          // },
          // {
          //   value: '2" Gold',
          //   price: 0,
          //   label: '2" Gold',
          //   color: "gold",
          //   depth: "2",
          //   selected: false,
          //   image:
          //     "https://canvas-prints-public.s3.amazonaws.com/CAF_6893+thumb.png",
          //   sku: "CP-OPT-FLOATER_FRAME_GOLD_2-0000-001",
          // },
          // {
          //   value: '1.25" Espresso',
          //   price: 0,
          //   label: '.75" Espresso',
          //   color: "espresso",
          //   depth: "1-25",
          //   selected: false,
          //   image:
          //     "https://canvas-prints-public.s3.amazonaws.com/CAF_6910+thumb.png",
          //   sku: "CP-OPT-FLOATER_FRAME_ESPRESSO_1.25-0000-001",
          // },
          {
            value: '2" Espresso',
            price: 0,
            label: '1.25" Espresso',
            color: "espresso",
            depth: "2",
            selected: false,
            image:
              "https://canvas-prints-public.s3.amazonaws.com/CAF_6910+thumb.png",
            sku: "CP-OPT-FLOATER_FRAME_ESPRESSO_2-0000-001",
          },
          // {
          //   value: '1.25" Natural',
          //   price: 0,
          //   label: '.75" Natural',
          //   color: "natural",
          //   depth: "1-25",
          //   selected: false,
          //   image:
          //     "https://canvas-prints-public.s3.amazonaws.com/CAF_6882+thumb.png",
          //   sku: "CP-OPT-FLOATER_FRAME_NATURAL_1.25-0000-001",
          // },
          {
            value: '2" Natural',
            price: 0,
            label: '1.25" Natural',
            color: "natural",
            depth: "2",
            selected: false,
            image:
              "https://canvas-prints-public.s3.amazonaws.com/CAF_6882+thumb.png",
            sku: "CP-OPT-FLOATER_FRAME_NATURAL_2-0000-001",
          },
          // {
          //   value: '1.25" Barnwood Gray',
          //   price: 0,
          //   label: '1.25" Barnwood Gray',
          //   color: "barnwood",
          //   depth: "1-25",
          //   selected: false,
          //   image:
          //     "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/barnwood.jpg",
          //   sku: "CP-OPT-FLOATER_FRAME_BARNWOOD_1.25-0000-001",
          // },
          // {
          //   value: '2" Barnwood Gray',
          //   price: 0,
          //   label: '2" Barnwood Gray',
          //   color: "barnwood",
          //   depth: "2",
          //   selected: false,
          //   image:
          //     "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/barnwood.jpg",
          //   sku: "CP-OPT-FLOATER_FRAME_BARNWOOD_2-0000-001",
          // },
        ],
        enabledIn: [
          DEV_ENVIRONMENT,
          STAGING_ENVIRONMENT,
          PRODUCTION_ENVIRONMENT,
        ],
      },
      // {
      //   label: "metal_easel",
      //   name: "METAL EASEL",
      //   handle: METAL_EASEL,
      //   title: "Metal Easel",
      //   cod_tooltip_inner: "Metal Easel",
      //   type: "image",
      //   selected: true,
      //   index: 7,
      //   values: [
      //     {
      //       value: "No",
      //       price: 0,
      //       selected: true,
      //       label: "No",
      //       sku: "CP-OPT-MTL_EASEL-NONE-0000-001",
      //     },
      //     {
      //       value: "Yes (+$11.99)",
      //       price: 11.99,
      //       label: "Yes",
      //       selected: false,
      //       image:
      //         "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/easel_1.jpg?v=1660589162",
      //       image2:
      //         "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/easel_1.jpg?v=1660589162",
      //       sku: "CP-OPT-MTL_EASEL-0000-001",
      //     },
      //   ],
      //   enabledIn: [
      //     DEV_ENVIRONMENT,
      //     STAGING_ENVIRONMENT,
      //     PRODUCTION_ENVIRONMENT,
      //   ],
      // },
      {
        label: "mounting_studs",
        name: "MOUNTING STUDS",
        handle: MOUNTING_STUDS,
        title: "Mounting Studs",
        cod_tooltip_inner: "Mounting Studs for Glass Prints",
        type: "select",
        index: 8,
        values: [
          {
            label: "Yes (+$6.99)",
            value: "Yes (+$6.99)",
            price: 6.99,
            selected: false,
            sku: "CP-OPT-MOUNTING_STUDS_YES-0000-001",
          },
          {
            label: "No",
            value: "No",
            price: 0,
            selected: true,
            sku: "CP-OPT-MOUNTING_STUDS_NO-0000-001",
          },
        ],
        enabledIn: [
          DEV_ENVIRONMENT,
          STAGING_ENVIRONMENT,
          PRODUCTION_ENVIRONMENT,
        ],
      },
      {
        label: "next_day_shipping_promo",
        name: "PRIORITY PRODUCTION",
        handle: NEXT_DAY_SHIPPING_PROMO,
        title: "Priority Production",
        cod_tooltip_inner:
          "Standard Processing may be 14-20 days but Priority Processing may be 2-3 days.",
        type: "checkbox",
        index: 12,
        values: [
          {
            label: "Yes (+$4.99)",
            value: "Yes (+$4.99)",
            price: 4.99,
            selected: false,
            sku: "CP-OPT-NDS_YES-0000-001",
          },
          {
            label: "No",
            value: "No",
            price: 0,
            selected: true,
            sku: "CP-OPT-NDS_NO-0000-001",
          },
        ],
        enabledIn: [
          DEV_ENVIRONMENT,
          STAGING_ENVIRONMENT,
          PRODUCTION_ENVIRONMENT,
        ],
      },
    ];

    // These objects all had a hardcoded index key, starting with an index of 1. That key has been removed, and at
    // the end of this method we loop through each object in the array and add this index before returning it. If you
    // need to add a object to the options array then it needs to be added at the bottom of the file. We don't want
    // to randomly re-order the index values for the items in this array.

    // Generate index values
    let currentIndex = 1;
    features.options = features.options.map((record) => {
      if (!record.hasOwnProperty("index")) {
        record["index"] = currentIndex;
        currentIndex++;
      }
      return record;
    });

    features.options = features.options.filter((feature) => {
      return feature.enabledIn.includes(this.currentEnv());
    });

    return features;
  }

  /**
   *
   * @param string[] optionOrder - The order you want options to be returned in. Optional.
   * @param object[] options - The features that are currently available
   * @returns object[]
   */
  orderOptions(optionOrder, options) {
    // Pseudocode: To be filled in by Elva team
    //
    // Re-order the contents of features.options based on the contents of
    // optionOrder. The contents of optionOrder should be equal to
    // the `handle` property of each javascript object. If optionOrder is ['digital-proofs', 'next-day-shipping']
    // then the contents of features.options that is returned out of this function should only contain
    // the objects for DIGITAL PROOF and PRIORITY PRODUCTION.
    //
    // If optionOrder is empty, there's no need to perform this reordering. Return the array as-is.
  }
}
